export enum CreatePasswordStatus {
    setting_password,
    confirm_sms_code,
    configuration_mfa,
    config_done,
}
